export default __webpack_public_path__ + "static/media/page1_bottom.64576d8a.png";